import Cookies from "js-cookie";

export type LANGUAGE_OPTION_TYPES = "eng" | "fr" | "es";

export const LANGUAGE_OPTIONS: LANGUAGE_OPTION_TYPES[] = ["eng", "fr", "es"];

export const getCurrentLanguage = (): LANGUAGE_OPTION_TYPES => {
  const stored = Cookies.get("language");
  if (stored && LANGUAGE_OPTIONS.includes(stored as LANGUAGE_OPTION_TYPES)) {
    return stored as LANGUAGE_OPTION_TYPES;
  }
  return "eng";
};
